import { FadeUp, RevealLine } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    t: "The device is the perimeter.",
    b: "You cannot defend a network if the endpoint has already been compromised at the manufacturer. GrapheneOS is the only phone stack that we will bet a threat model on.",
  },
  {
    n: "02",
    t: "Trust the boot, not the vendor.",
    b: "Verified boot with your own key. Locked bootloader. Hardware attestation confirms the OS is exactly what we shipped. No signed blob from Mountain View touches the storage.",
  },
  {
    n: "03",
    t: "Silence is a system property.",
    b: "Microphones can be muted, then re-enabled. In the Phantom tier we remove them. If it is not physically present, it cannot be socially engineered back on.",
  },
  {
    n: "04",
    t: "Sydney sovereignty.",
    b: "We hardware-harden in Australia. Chain of custody documented, batch numbers signed, Faraday-shipped where requested. Owned outright by Australians, no offshore silent partners.",
  },
  {
    n: "05",
    t: "Zero-knowledge, all the way down.",
    b: "We never see your data, and we do not want to. Our infrastructure holds order metadata only. Devices are wiped after final QA and delivered locked to your fingerprint alone.",
  },
];

export default function Manifesto() {
  return (
    <div className="pt-32 pb-24 px-6 md:px-10" data-testid="manifesto-page">
      <div className="overline mb-6">Ξ 010 — Doctrine</div>
      <h1 className="font-display uppercase text-6xl md:text-9xl tracking-tight leading-[0.9]">
        <RevealLine i={0}>The Phantom Phone</RevealLine>
        <RevealLine i={1}>manifesto.</RevealLine>
      </h1>
      <FadeUp delay={0.2}>
        <p className="mt-12 max-w-2xl text-[#888] text-lg leading-relaxed">
          A short set of principles that dictate every device we assemble, every line of shipped configuration,
          and every conversation we have with the people who buy from us.
        </p>
      </FadeUp>

      <div className="mt-32 space-y-32">
        {CHAPTERS.map((c, i) => (
          <FadeUp key={c.n}>
            <div className="grid grid-cols-12 gap-6 md:gap-10 items-start border-t border-[#1A1A1A] pt-16">
              <div className="col-span-12 md:col-span-3">
                <div className="font-display text-[8rem] md:text-[10rem] leading-none text-[#222]">{c.n}</div>
              </div>
              <div className="col-span-12 md:col-span-9">
                <h2 className="font-display uppercase text-3xl md:text-5xl tracking-tight leading-[0.95]">{c.t}</h2>
                <p className="mt-8 text-[#888] text-base md:text-lg leading-relaxed max-w-3xl">{c.b}</p>
              </div>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  );
}
